// extracted by mini-css-extract-plugin
export default {"wrapper":"floating-buttons_wrapper__SAlsI","justify-right":"floating-buttons_justify-right__E1M50","full-width":"floating-buttons_full-width__iK+Q+"};